import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * Estado vazio.
 *
 * Diz *por que* não há nada — "ninguém criou ainda" e "você não tem permissão"
 * são situações diferentes e exigem ações diferentes de quem lê. Um traço
 * mudo no lugar do número não permite distinguir.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3 rounded-lg border border-dashed border-border px-6 py-10 text-center',
        className,
      )}
    >
      {icon ? (
        <span aria-hidden className="text-muted-foreground/70">
          {icon}
        </span>
      ) : null}
      <div className="space-y-1">
        <p className="text-sm font-medium">{title}</p>
        {description ? (
          <p className="mx-auto max-w-md text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
